// Prototypebryteren (BRUK-08): hubben kjører med SKADE_PROTOTYPE_AAPEN_TILGANG=1
// og sier det i `/auth/me` og innloggingssvaret (`prototypeAapen`). COP-en
// bruker flagget BARE til å speile: vise Brukere-valget for alle, gi hele
// rollelista i skjemaene, vise redigeringsknappene i Sensorer. Hubben avgjør
// (grunnlov §4: klient-gating er aldri nok alene). Settes én gang i main.ts
// før noe panel bootes; i demo-modus (uten hub) er den alltid av.
let aapen = false;

export function settPrototypeAapen(v: boolean): void { aapen = v; }

export function prototypeAapen(): boolean { return aapen; }

// COP-ENHET-03 (eier 31.10: «Alle i TOC»): hubben sier i `/auth/me` og
// innloggingssvaret om brukeren har TOC-profil eller TOC-rolle
// (`kanFjerneAndresEnheter`). COP bruker det BARE til å vise «Fjern fra kartet»
// på enheter andre har plassert; hubben avgjør hver fjerning selv
// (`POST /kart/enheter/fjern`). Av i demo-modus (ingen hub å spørre).
let fjerneAndres = false;

export function settKanFjerneAndresEnheter(v: boolean): void { fjerneAndres = v; }

export function kanFjerneAndresEnheter(): boolean { return fjerneAndres; }
